<template>
    <div class="w-full">
        <div
            class="grid grid-cols-2 gap-4 pt-3 pb-4 md:grid-cols-3"
            :class="[
                loading ? 'xl:gap-8 2xl:gap-12' : 'xl:gap-6',
                filtersVisible ? 'lg:grid-cols-3' : 'lg:grid-cols-4',
            ]">
            <template v-if="loading">
                <div v-for="i in 12" :key="`skeleton-${i}`" class="animate-pulse">
                    <div class="aspect-3/4 w-full rounded bg-gray-200"></div>
                    <div class="mt-2 h-4 w-3/4 rounded bg-gray-200"></div>
                    <div class="mt-1 h-4 w-full rounded bg-gray-200"></div>
                    <div class="mt-1 h-5 w-1/3 rounded bg-gray-200"></div>
                </div>
            </template>
            <template v-else>
                <div v-for="product in products" :key="product.id" :data-product-id="product.id">
                    <ShopwareProduct :product="product" />
                </div>
            </template>
        </div>
    </div>
</template>

<script setup lang="ts">
    const props = defineProps<{ products: any[]; loading: boolean }>();
    const filtersVisible = inject<Ref<boolean>>('filtersVisible', ref(true));
    const route = useRoute();

    const { trackProductList } = useGTMEcommerce();

    function queryStr(val: unknown): string {
        if (Array.isArray(val)) return (val[0] as string) || '';
        return (val as string) || '';
    }

    /** `view_search_results` is sent from `BlockProductListingLayout`; avoid duplicate `view_item_list` on text search URLs. */
    function isTextSearchListing(): boolean {
        return Boolean(queryStr(route.query.tn_q) || queryStr(route.query.search));
    }

    onMounted(() => {
        if (isTextSearchListing()) return;

        const visibleProducts = props.products?.filter((p: any) => p.coverId) ?? [];
        if (visibleProducts.length > 0) {
            const firstProduct: any = visibleProducts[0];
            const categoryName = firstProduct?.categories?.[firstProduct.categories.length - 1]?.translated?.name || '';
            const item_list_id = String(firstProduct?.categoryTree || '');
            trackProductList(visibleProducts, item_list_id, categoryName);
        }
    });
</script>
